import { render } from "./AutoCompleteField.vue?vue&type=template&id=56afdb8c"
import script from "./AutoCompleteField.vue?vue&type=script&lang=js"
export * from "./AutoCompleteField.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__